/**
 * Leasing Dashboard — boundary contract schemas.
 *
 * Owned here, not beside the route: `apps/api/src/routes/manager/leasing-dashboard.schemas.ts`
 * imports and re-exports this to register the route, and
 * `apps/landlord/src/lib/leasing.api.ts` derives its `UpcomingShowingItem` type from the
 * same object. See packages/api-types/README.md.
 *
 * Covers:
 *   GET /landlord/api/dashboard/showings  (portfolio-wide upcoming showings, Change 16)
 *   GET /landlord/api/applications        (cross-listing applicant index, Iteration 7)
 */
import { z } from 'zod';
export const UpcomingShowingItemSchema = z.object({
    id: z.uuid(),
    kind: z.enum(['confirmed', 'pending']),
    scheduledFor: z.string(),
    leadId: z.uuid().nullable(),
    prospectName: z.string().nullable(),
    listingId: z.uuid(),
    listingAddress: z.string(),
    timezone: z.string(),
});
// ---------------------------------------------------------------------------
// Applications endpoint — GET /landlord/api/applications
// ---------------------------------------------------------------------------
export const ApplicationItemSchema = z.object({
    applicantId: z.uuid(),
    applicantName: z.string(),
    applicantEmail: z.string(),
    role: z.enum(['primary', 'co_applicant', 'guarantor']),
    status: z.enum(['invited', 'started', 'submitted']),
    leadId: z.uuid(),
    prospectName: z.string().nullable(),
    prospectEmail: z.string(),
    listingId: z.uuid(),
    listingAddress: z.string(),
    submittedAt: z.string().nullable(),
    invitedAt: z.string(),
    lastActivityAt: z.string(),
});
//# sourceMappingURL=dashboard.js.map